import { ROUTE_CONTACT, ROUTE_PRIVACY, EXTERNAL_ROUTE_IMPRINT } from '@/constants/routes';

export default [
  {
    text: 'Kontakt',
    link: ROUTE_CONTACT,
    external: true,
  },
  {
    text: 'Datenschutz',
    link: ROUTE_PRIVACY,
    external: true,
  },
  {
    text: 'Impressum',
    link: EXTERNAL_ROUTE_IMPRINT,
    external: true,
  },
];
